import { useState, useEffect, useCallback } from "react";
const API = process.env.REACT_APP_BACKEND_URL;

export function useWallet(pollMs = 15000) {
  const [balance, setBalance] = useState(null);
  const [tickets, setTickets] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const [r, t] = await Promise.all([
        fetch(`${API}/api/wallet/me`, { credentials: "include" }),
        fetch(`${API}/api/tickets/me`, { credentials: "include" }),
      ]);
      if (r.ok) setBalance((await r.json()).balance_cents);
      else setBalance(null);
      if (t.ok) setTickets((await t.json()).balance ?? 0);
      else setTickets(null);
    } catch { setBalance(null); setTickets(null); }
    finally { setLoading(false); }
  }, []);

  useEffect(() => {
    refresh();
    if (!pollMs) return;
    const t = setInterval(refresh, pollMs);
    return () => clearInterval(t);
  }, [refresh, pollMs]);

  return { balance, tickets, loading, refresh };
}

export function fmtUsd(cents) {
  if (cents == null) return "—";
  return `$${(cents / 100).toFixed(2)}`;
}
